module.exports = __webpack_public_path__ + "6aa10430496067bfd7a2a1ff5e6ed6bf.svg";